import { Suspense, lazy } from "react";
import { Navigate, useRoutes, useLocation } from "react-router-dom";
// loadibng components
import LoadingScreen from "./../components/LoadingScreen";
import AuthGuard from "../guards/AuthGuard";
import FinanceProceed from "../components/_financer/loanOffers/FinanceProceed";
const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense
      fallback={<LoadingScreen isDashboard={pathname.includes("/financer")} />}
    >
      <Component {...props} />
      {/* <LoadingScreen isDashboard={pathname.includes("/dashboard")} /> */}
    </Suspense>
  );
};
// view details
const FinancierBasicInfo = Loadable(
  lazy(() => import("../pages/financer/Statements/FinancierBasicInfo"))
);

const FinancierScores = Loadable(
  lazy(() => import("../pages/financer/Statements/FinancierScores"))
);
const FinancierFinancialStatementView = Loadable(
  lazy(() =>
    import("../pages/financer/Statements/FinancierFinancialStatementView")
  )
);

const FinancierBankStatmentView = Loadable(
  lazy(() => import("../pages/financer/Statements/FinancierBankStatmentView"))
);

const FinancierCibilStatementView = Loadable(
  lazy(() => import("../pages/financer/Statements/FinancierCibilStatementView"))
);
//financer quote request
const FinancerDashboard = Loadable(
  lazy(() => import("./../pages/financer/FinancerDashboard"))
);
const LoanQualificationPage = Loadable(
  lazy(() =>
    import("./../pages/financer/LoanQualification/LoanQualificationPage")
  )
);
const FinancerProfile = Loadable(
  lazy(() => import("./../pages/financer/FinancerProfile"))
);
const FinancerEditProfile = Loadable(
  lazy(() => import("./../pages/financer/FinancerEditProfile"))
);
const LoanOffersPage = Loadable(
  lazy(() => import("./../pages/financer/LoanOffers/LoanOffersPage"))
);
const LoanOffersDetailPage = Loadable(
  lazy(() => import("../pages/financer/LoanOffers/LoanOffersDetailPage"))
);

const FinancerAddress = Loadable(
  lazy(() => import("../pages/financer/Address/FinancerAddress"))
);
export const financerRoutes = [
  {
    path: "",
    element: (
      <AuthGuard>
        <FinancerDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "loan-qualification",
    element: (
      <AuthGuard>
        <LoanQualificationPage />
      </AuthGuard>
    ),
  },
  {
    path: "address",
    element: (
      <AuthGuard>
        <FinancerAddress />
      </AuthGuard>
    ),
  },
  {
    path: "profile",
    element: (
      <AuthGuard>
        <FinancerProfile />
      </AuthGuard>
    ),
  },
  {
    path: "profile/edit",
    element: (
      <AuthGuard>
        <FinancerEditProfile />
      </AuthGuard>
    ),
  },
  {
    path: "loan-offers",
    element: (
      <AuthGuard>
        <LoanOffersPage />
      </AuthGuard>
    ),
  },
  {
    path: "proceed/:id",
    element: (
      <AuthGuard>
        <FinanceProceed />
      </AuthGuard>
    ),
  },
  {
    path: "loan-offers/details",
    element: (
      <AuthGuard>
        <LoanOffersDetailPage />
      </AuthGuard>
    ),
    children: [
      // { element: <Navigate to="/supplier/onboarding/basic-info" replace /> },
      {
        path: "personal-info",
        element: <FinancierBasicInfo />,
      },
      {
        path: "personal-financial",
        element: <FinancierFinancialStatementView />,
      },
      { path: "personal-bank", element: <FinancierBankStatmentView /> },
      { path: "personal-cibil", element: <FinancierCibilStatementView /> },
      { path: "scores", element: <FinancierScores /> },
    ],
  },
];
